import { render, staticRenderFns } from "./RewardPeriodDetailOverall.vue?vue&type=template&id=f6a425e0"
import script from "./reward-period-detail-overall.ts?vue&type=script&lang=ts&external"
export * from "./reward-period-detail-overall.ts?vue&type=script&lang=ts&external"
import style0 from "./reward-period-detail-overall.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports